import type { Stripe } from '@stripe/stripe-js';
import { loadStripe } from '@stripe/stripe-js/pure';

export const getStripeInstance = async (): Promise<Stripe | null> => {
  const stripePK = process.env.VITE_STRIPE_PK ?? process.env.NEXT_PUBLIC_STRIPE_KEY;
  return await loadStripe(stripePK as string);
};
